<template>
  <div class="card__list">
    <template v-if="isLoading">
      <ReportCardPlaceholder
        v-for="item in 8"
        :key="item"
      ></ReportCardPlaceholder>
    </template>
    <template v-else>
      <ReportCard
        v-for="report in reports"
        :key="report.id"
        :report="report"
      ></ReportCard>
    </template>
  </div>
</template>

<script>
import ReportCard from "@/components/common/report-card/ReportCard.vue";
import ReportCardPlaceholder from "@/components/common/report-card/ReportCardPlaceholder.vue";

import { mapState } from "vuex";

export default {
  components: {
    ReportCard,
    ReportCardPlaceholder,
  },
  props: {
    reports: {
      type: Array,
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.report.isLoading,
    }),
  },
};
</script>

<style lang="scss" scoped>
.card {
  &__list {
    margin-bottom: 10rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(256px, 1fr));
    grid-gap: 15px;
  }
}
</style>
